// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3p2NV","modalForm":"UpgradeEpcsModal_modalForm__2hrPB","modalFooter":"UpgradeEpcsModal_modalFooter__HEmqq"};